// import React, { useState, useEffect, useRef } from "react";
// import Select from "react-select";
// import countryList from "react-select-country-list";
// import {
//   Backdrop, Button, CircularProgress, Dialog, DialogActions,
//   DialogContent, DialogContentText, DialogTitle, TextField,
//   Typography, Box, SwipeableDrawer, styled, useTheme, InputAdornment
// } from "@mui/material";
// import { Formik, Form, Field, ErrorMessage } from "formik";
// import * as Yup from "yup";
// import PhoneInput, { isValidPhoneNumber, getCountries, getCountryCallingCode } from "react-phone-number-input";
// import "react-phone-number-input/style.css";
// import { t } from "i18next";
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import axios from "axios";
// import Loading from "../../../common/loading";
// import { getLocalStorageMenuItem, setLocalStorageMenuItem } from "../../../utility";
// import SaveCustomerNameDialog from "../../SaveCustomerNameDialog";
// import { useLocation, useNavigate } from "react-router-dom";
// import Toast from "../../../common/toast";
// import ReactCountryFlag from "react-country-flag";

// // Styled components for the split phone input
// const PhoneInputContainer = styled(Box)(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   gap: '8px',
//   width: '100%',
//   border: `1px solid ${theme.palette.divider}`,
//   borderRadius: '8px',
//   padding: '4px 12px',
//   transition: theme.transitions.create(['border-color', 'box-shadow']),
//   '&:hover': {
//     borderColor: theme.palette.primary.main,
//   },
//   '&:focus-within': {
//     borderColor: theme.palette.primary.main,
//     boxShadow: `0 0 0 2px ${theme.palette.primary.light}`,
//   },
// }));

// const CountrySelector = styled(Box)(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   gap: '8px',
//   padding: '8px 0',
//   minWidth: '120px',
//   borderRight: `1px solid ${theme.palette.divider}`,
//   paddingRight: '12px',
//   cursor: 'pointer',
// }));

// const PhoneNumberInput = styled(TextField)(({ theme }) => ({
//   flexGrow: 1,
//   '& .MuiOutlinedInput-root': {
//     border: 'none',
//     '&:hover fieldset': {
//       border: 'none',
//     },
//     '&.Mui-focused fieldset': {
//       border: 'none',
//     },
//     '& input': {
//       padding: '8px 0',
//       border: 'none',
//       outline: 'none',
//     },
//   },
//   '& .MuiOutlinedInput-notchedOutline': {
//     border: 'none',
//   },
// }));

// const CountrySelectDropdown = ({ value, onChange, onBlur, ...props }) => {
//   const theme = useTheme();
//   const options = React.useMemo(() =>
//     getCountries().map(country => ({
//       value: country,
//       label: `${country} +${getCountryCallingCode(country)}`,
//       callingCode: getCountryCallingCode(country)
//     })),
//     []);

//   const selectedOption = options.find(option => option.value === value) || options.find(option => option.value === "SA");

//   return (
//     <Select
//       {...props}
//       options={options}
//       value={selectedOption}
//       onChange={(option) => onChange(option.value)}
//       onBlur={onBlur}
//       components={{
//         IndicatorSeparator: () => null,
//         DropdownIndicator: () => null,
//       }}
//       formatOptionLabel={(option) => (
//         <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//           <ReactCountryFlag
//             countryCode={option.value}
//             svg
//             style={{ width: "1.5em", height: "1.5em" }}
//           />
//           <span>+{option.callingCode}</span>
//         </div>
//       )}
//       styles={{
//         control: (base, state) => ({
//           ...base,
//           border: 'none',
//           boxShadow: 'none',
//           backgroundColor: 'transparent',
//           minHeight: 'auto',
//           '&:hover': {
//             border: 'none',
//           },
//         }),
//         valueContainer: (base) => ({
//           ...base,
//           padding: 0,
//         }),
//         singleValue: (base) => ({
//           ...base,
//           margin: 0,
//           display: 'flex',
//           alignItems: 'center',
//           gap: '8px',
//         }),
//         menu: (base) => ({
//           ...base,
//           zIndex: 9999,
//           borderRadius: 12,
//           overflow: "hidden",
//           boxShadow: theme.shadows[4],
//           minWidth: "250px",
//         }),
//         option: (base, state) => ({
//           ...base,
//           fontSize: "0.9rem",
//           padding: "10px 14px",
//           backgroundColor: state.isSelected
//             ? theme.palette.primary.main
//             : state.isFocused
//               ? theme.palette.action.hover
//               : "transparent",
//           color: state.isSelected
//             ? theme.palette.primary.contrastText
//             : theme.palette.text.primary,
//           cursor: "pointer",
//           transition: "background-color 0.2s ease",
//         }),
//       }}
//     />
//   );
// };

// const VerificationCodeInput = ({ value, onChange, error }) => {
//   const theme = useTheme();
//   const inputRefs = useRef([]);
//   const [digits, setDigits] = useState(Array(6).fill(''));

//   useEffect(() => {
//     if (value && value.length === 6) {
//       const newDigits = value.split('');
//       setDigits(newDigits);
//       if (inputRefs.current[5]) {
//         inputRefs.current[5].focus();
//       }
//     }
//   }, [value]);

//   const handleChange = (index, newValue) => {
//     if (newValue && !/^\d*$/.test(newValue)) return;

//     const newDigits = [...digits];
//     if (newValue.length === 6) {
//       const pastedDigits = newValue.split('').slice(0, 6);
//       setDigits(pastedDigits);
//       onChange(pastedDigits.join(''));
//       // Focus the last input
//       if (inputRefs.current[5]) {
//         inputRefs.current[5].focus();
//       }
//       return;
//     }

//     newDigits[index] = newValue.slice(-1);
//     setDigits(newDigits);
//     const code = newDigits.join('');
//     onChange(code);

//     if (newValue && index < 5) {
//       inputRefs.current[index + 1].focus();
//     }
//   };

//   const handleKeyDown = (index, e) => {
//     if (e.key === 'Backspace' && !digits[index] && index > 0) {
//       inputRefs.current[index - 1].focus();
//     }
//     if (e.key === 'ArrowLeft' && index > 0) {
//       inputRefs.current[index - 1].focus();
//       e.preventDefault();
//     }
//     if (e.key === 'ArrowRight' && index < 5) {
//       inputRefs.current[index + 1].focus();
//       e.preventDefault();
//     }
//   };

//   const handlePaste = (e) => {
//     e.preventDefault();
//     const pastedData = e.clipboardData.getData('text').trim();
//     if (!/^\d+$/.test(pastedData)) return; // ignore non-numeric paste

//     const chars = pastedData.split('').slice(0, 6); // take up to 6 digits
//     const newDigits = Array(6).fill('');
//     for (let i = 0; i < chars.length; i++) newDigits[i] = chars[i];
//     setDigits(newDigits);
//     onChange(newDigits.join(''));

//     const nextIndex = Math.min(chars.length, 5);
//     if (inputRefs.current[nextIndex]) inputRefs.current[nextIndex].focus();
//   }

//   return (
//     <Box sx={{
//       display: 'flex',
//       justifyContent: 'center',
//       gap: 1,
//       mb: 2,
//       direction: 'ltr',
//     }}>
//       {digits.map((digit, index) => (
//         <TextField
//           key={index}
//           inputRef={(el) => (inputRefs.current[index] = el)}
//           value={digit}
//           onChange={(e) => handleChange(index, e.target.value)}
//           onKeyDown={(e) => handleKeyDown(index, e)}
//           onPaste={handlePaste}
//           inputProps={{
//             maxLength: index === 0 ? 6 : 1,
//             inputMode: 'numeric',
//             pattern: '[0-9]*',
//             style: {
//               textAlign: 'center',
//               fontSize: '1.5rem',
//               fontWeight: 'bold',
//               direction: 'ltr',
//               height: "50px",
//               width: "50px"
//             }
//           }}
//           sx={{
//             width: '150px',
//             height: '50px',
//             direction: 'ltr',
//             '& .MuiOutlinedInput-root': {
//               borderRadius: '8px',
//               direction: 'ltr',
//               '& input': {
//                 textAlign: 'center',
//                 padding: '0',
//                 direction: 'ltr',
//               },
//               '& fieldset': {
//                 borderColor: error ? theme.palette.error.main : theme.palette.divider,
//               },
//               '&:hover fieldset': {
//                 borderColor: error ? theme.palette.error.main : theme.palette.primary.main,
//               },
//               '&.Mui-focused fieldset': {
//                 borderColor: error ? theme.palette.error.main : theme.palette.primary.main,
//                 borderWidth: '2px',
//               },
//             }
//           }}
//           variant="outlined"
//         />
//       ))}
//     </Box>
//   );
// };

// const LoginComponent = ({ open, handleCloseDialog, tableQr, tableName, onVerificationSuccess, is_from }) => {
//   const theme = useTheme();
//   const [verificationCode, setVerificationCode] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [phone, setPhone] = useState("");
//   const [country, setCountry] = useState("SA");
//   const [phoneNumber, setPhoneNumber] = useState("");
//   const [openVerifiyDialog, setOpenVerifiyDialog] = useState(false);
//   const [customerName, setCustomerName] = useState("");
//   const [openSaveNameDialog, setOpenSaveNameDialog] = useState(false);
//   const [token, setToken] = useState("");
//   const [resendTimer, setResendTimer] = useState(0);
//   const [codeSentTime, setCodeSentTime] = useState(null);
//   const [verificationError, setVerificationError] = useState("");
//   const [toastSettings, setToastSettings] = useState({
//     open: false,
//     message: "",
//     success: false,
//   });

//   useEffect(() => {
//     let timer;
//     if (resendTimer > 0) {
//       timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
//     }
//     return () => clearTimeout(timer);
//   }, [resendTimer]);


//   useEffect(() => {
//     if (verificationCode.length === 6) {
//       handleVerifyCode();
//     }
//   }, [verificationCode]);

//   const startResendTimer = () => {
//     setResendTimer(120);
//     setCodeSentTime(new Date());
//   };

//   const formatTime = (seconds) => {
//     const mins = Math.floor(seconds / 60);
//     const secs = seconds % 60;
//     return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
//   };

//   const handleOpenToast = (message, state) => {
//     setToastSettings({
//       open: true,
//       success: state,
//       message: message
//     });
//   };

//   const handleCloseToast = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }
//     setToastSettings({
//       open: false,
//       message: "",
//       success: false
//     });
//   };

//   function useQueryParams() {
//     const { search } = useLocation();
//     return new URLSearchParams(search);
//   }

//   const navigate = useNavigate();
//   const query = useQueryParams();
//   const tParam = query.get("t");
//   const lang = query.get("lang");

//   const validationSchema = Yup.object().shape({
//     phoneNumber: Yup.string()
//       .required(t("Phone number is required"))
//       .test(
//         "isValidPhoneNumber",
//         t("Enter a valid phone number"),
//         (value) => {
//           if (!value) return false;
//           // Combine country code and phone number for validation
//           const fullNumber = `+${getCountryCallingCode(country)}${value.replace(/\D/g, '')}`;
//           return isValidPhoneNumber(fullNumber);
//         }
//       ),
//   });

//   const handleOpenSaveNameDialog = (token) => {
//     setToken(token);
//     setOpenVerifiyDialog(false);
//     setOpenSaveNameDialog(true);
//   }

//   const saveCustomerName = async () => {
//     if (!customerName) {
//       handleOpenToast(
//         <div className="alignByLang">
//           {t("Please enter your name.")}
//         </div>,
//         false
//       );
//       return;
//     }

//     setLoading(true);
//     try {
//       const response = await axios.post(`${process.env.REACT_APP_API}/customer/save-name`, {
//         name: customerName,
//       }, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         }
//       });

//       if (response?.data?.success) {
//         handleOpenToast(
//           <div className="alignByLang">
//             {t("Name updated successfully.")}
//           </div>,
//           true
//         );
//         setLocalStorageMenuItem("mobileLoginToken", token || "");
//         setLocalStorageMenuItem("customer_name", customerName || "");
//         setLocalStorageMenuItem("customer_balance", 0);
//         onVerificationSuccess(token);
//         setOpenSaveNameDialog(false);
//       } else {
//         handleOpenToast(
//           <div className="alignByLang">
//             {t("Error while saving the name.")}
//           </div>,
//           false
//         );
//       }
//     } catch (error) {
//       handleOpenToast(
//         <div className="alignByLang">
//           {t("Error while saving the name: ") + error.message}
//         </div>,
//         false
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSendCode = async (values) => {
//     setLoading(true);
//     try {
//       // Format the phone number with country code
//       const fullPhoneNumber = `+${getCountryCallingCode(country)}${values.phoneNumber.replace(/\D/g, '')}`;

//       const response = await axios.post(`${process.env.REACT_APP_API}/customer/send-otp`, {
//         phone: fullPhoneNumber,
//         menu_code: tableQr,
//       });

//       if (response?.data?.success) {
//         setPhone(fullPhoneNumber);
//         // await handleVerifyCodeTemp(fullPhoneNumber, "123456");
//         handleCloseDialog();

//         setOpenVerifiyDialog(true);
//         startResendTimer();
//         handleOpenToast(
//           <div className="alignByLang">
//             {t("Verification code sent successfully.")}
//           </div>,
//           true
//         );
//       } else {
//         handleOpenToast(
//           <div className="alignByLang">
//             {t("Error while sending the verification code.")}
//           </div>,
//           false
//         );
//       }
//     } catch (error) {
//       handleOpenToast(
//         <div className="alignByLang">
//           {t("Error while sending the verification code: ") + error.message}
//         </div>,
//         false
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleResendCode = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.post(`${process.env.REACT_APP_API}/customer/send-otp`, {
//         phone: phone,
//         menu_code: tableQr,
//       });

//       if (response?.data?.success) {
//         startResendTimer();
//         handleOpenToast(
//           <div className="alignByLang">
//             {t("New verification code sent successfully.")}
//           </div>,
//           true
//         );
//       } else {
//         handleOpenToast(
//           <div className="alignByLang">
//             {t("Error while resending the verification code.")}
//           </div>,
//           false
//         );
//       }
//     } catch (error) {
//       handleOpenToast(
//         <div className="alignByLang">
//           {t("Error while resending the verification code: ") + error.message}
//         </div>,
//         false
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleVerifyCode = async () => {
//     if (!verificationCode || verificationCode.length !== 6) {
//       setVerificationError(t("Please enter a valid 6-digit code"));
//       return;
//     }

//     setLoading(true);
//     setVerificationError("");

//     try {
//       const response = await axios.post(`${process.env.REACT_APP_API}/customer/check-otp`, {
//         phone,
//         otp: verificationCode,
//       });

//       if (response?.data?.success) {
//         setVerificationCode("");
//         if (response?.data?.data?.name) {
//           setLocalStorageMenuItem("customer_name", response?.data?.data?.name || "");
//           setLocalStorageMenuItem("customer_balance", response?.data?.data?.balance || 0);
//           setLocalStorageMenuItem("mobileLoginToken", response?.data?.data?.token || "");
//           onVerificationSuccess(response?.data?.data?.token);
//           setOpenVerifiyDialog(false);

//           if (is_from === 1) {
//             navigate(`/${tableName}/${tableQr}/sections?section=0&t=${tParam}&lang=${lang}`, { replace: true });
//           } else if (is_from === 2) {
//             window.location.reload();
//           }
//         } else {
//           handleOpenSaveNameDialog(response?.data?.data?.token);
//         }
//       } else {
//         setVerificationError(t("Invalid verification code. Please try again."));
//         handleOpenToast(
//           <div className="alignByLang">
//             {t("Invalid verification code. Please try again.")}
//           </div>,
//           false
//         );
//       }
//     } catch (error) {
//       setVerificationError(t("Error verifying code"));
//       handleOpenToast(
//         <div className="alignByLang">
//           {t("Error while verifying the code: ") + error.message}
//         </div>,
//         false
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleVerifyCodeTemp = async (temp_phone, code) => {
//     if (!code || code.length !== 6) {
//       setVerificationError(t("Please enter a valid 6-digit code"));
//       return;
//     }

//     setLoading(true);
//     setVerificationError("");

//     try {
//       const response = await axios.post(`${process.env.REACT_APP_API}/customer/check-otp`, {
//         phone: temp_phone,
//         otp: code,
//       });

//       if (response?.data?.success) {
//         setVerificationCode("");
//         if (response?.data?.data?.name) {
//           setLocalStorageMenuItem("customer_name", response?.data?.data?.name || "");
//           setLocalStorageMenuItem("customer_balance", response?.data?.data?.balance || 0);
//           setLocalStorageMenuItem("mobileLoginToken", response?.data?.data?.token || "");
//           onVerificationSuccess(response?.data?.data?.token);
//           setOpenVerifiyDialog(false);

//           if (is_from === 1) {
//             navigate(`/${tableName}/${tableQr}/sections?section=0&t=${tParam}&lang=${lang}`, { replace: true });
//           } else if (is_from === 2) {
//             window.location.reload();
//           }
//         } else {
//           handleOpenSaveNameDialog(response?.data?.data?.token);
//         }
//       } else {
//         setVerificationError(t("Invalid verification code. Please try again."));
//         handleOpenToast(
//           <div className="alignByLang">
//             {t("Invalid verification code. Please try again.")}
//           </div>,
//           false
//         );
//       }
//     } catch (error) {
//       setVerificationError(t("Error verifying code"));
//       handleOpenToast(
//         <div className="alignByLang">
//           {t("Error while verifying the code: ") + error.message}
//         </div>,
//         false
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Format phone number as user types (Saudi format)
//   const formatPhoneNumber = (value) => {
//     if (!value) return value;

//     // Remove all non-digit characters
//     const digitsOnly = value.replace(/\D/g, '');

//     // Apply Saudi format: 5X XXX XXXX
//     if (digitsOnly.length <= 1) return digitsOnly;
//     if (digitsOnly.length <= 4) return `${digitsOnly.slice(0, 1)} ${digitsOnly.slice(1)}`;
//     if (digitsOnly.length <= 7) return `${digitsOnly.slice(0, 1)} ${digitsOnly.slice(1, 4)} ${digitsOnly.slice(4)}`;
//     return `${digitsOnly.slice(0, 1)} ${digitsOnly.slice(1, 4)} ${digitsOnly.slice(4, 7)} ${digitsOnly.slice(7, 9)}`;
//   };

//   if (loading) {
//     return <Loading />;
//   }

//   return (
//     <div>
//       <ToastContainer />
//       <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
//         <CircularProgress color="inherit" />
//       </Backdrop>

//       {/* Phone Number Drawer */}
//       <SwipeableDrawer
//         anchor="bottom"
//         open={open}
//         onClose={handleCloseDialog}
//         onOpen={() => { }}
//         disableSwipeToOpen={true}
//         PaperProps={{
//           sx: {
//             borderTopLeftRadius: '16px',
//             borderTopRightRadius: '16px',
//             padding: theme.spacing(3, 2, 4),
//             background: theme.palette.background.paper,
//             boxShadow: theme.shadows[10],
//           }
//         }}
//       >
//         <Box sx={{ textAlign: 'center', mb: 2 }}>
//           <Box sx={{
//             width: '40px',
//             height: '4px',
//             backgroundColor: theme.palette.divider,
//             borderRadius: '2px',
//             margin: '0 auto 16px',
//           }} />
//           <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.text.primary, mb: 1 }}>
//             {t("Welcome")}
//           </Typography>
//           <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 3 }}>
//             {t("Enter your phone number to continue")}
//           </Typography>
//         </Box>

//         <Formik
//           initialValues={{ phoneNumber: "" }}
//           validationSchema={validationSchema}
//           onSubmit={handleSendCode}
//         >
//           {({ values, setFieldValue, errors, touched, handleBlur }) => (
//             <Form>
//               <PhoneInputContainer>
//                 <CountrySelector>
//                   <CountrySelectDropdown
//                     value={country}
//                     onChange={setCountry}
//                     onBlur={handleBlur}
//                   />
//                 </CountrySelector>
//                 <PhoneNumberInput
//                   name="phoneNumber"
//                   placeholder={t("Phone number")}
//                   value={values.phoneNumber}
//                   onChange={(e) => {
//                     let inputValue = e.target.value;
//                     if (inputValue.startsWith("0")) {
//                       inputValue = inputValue.substring(1);
//                     }
//                     const formatted = formatPhoneNumber(e.target.value);
//                     setFieldValue("phoneNumber", inputValue);
//                   }}
//                   onBlur={handleBlur}
//                   fullWidth
//                   variant="outlined"
//                   error={touched.phoneNumber && Boolean(errors.phoneNumber)}
//                   inputProps={{
//                     style: {
//                       textAlign: 'center',
//                       textAlign: getLocalStorageMenuItem("lang") === "ar" ? 'center' : 'center'
//                     }
//                   }}
//                   // Or if it uses InputProps instead:
//                   InputProps={{
//                     style: {
//                       textAlign: 'center',
//                       textAlign: getLocalStorageMenuItem("lang") === "ar" ? 'center' : 'center'
//                     }
//                   }}
//                 />
//               </PhoneInputContainer>

//               <ErrorMessage
//                 name="phoneNumber"
//                 component="div"
//                 style={{
//                   color: theme.palette.error.main,
//                   margin: '8px 0 16px',
//                   fontSize: '0.875rem',
//                   textAlign: 'center'
//                 }}
//               />

//               <Button
//                 type="submit"
//                 variant="contained"
//                 fullWidth
//                 size="large"
//                 sx={{
//                   mt: 2,
//                   py: 1.5,
//                   fontWeight: 'bold',
//                   textTransform: 'none',
//                   fontSize: '1rem',
//                   borderRadius: '12px',
//                   boxShadow: 'none',
//                   '&:hover': {
//                     boxShadow: 'none',
//                   }
//                 }}
//               >
//                 {t("Continue")}
//               </Button>
//             </Form>
//           )}
//         </Formik>
//       </SwipeableDrawer>

//       {/* Verification Code Dialog */}
//       <Dialog
//         open={openVerifiyDialog}
//         onClose={() => setOpenVerifiyDialog(false)}
//         fullWidth
//         maxWidth="sm"
//         PaperProps={{
//           sx: {
//             borderRadius: '16px',
//             padding: theme.spacing(3),
//             background: theme.palette.background.paper,
//           }
//         }}
//       >
//         <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', px: 0, pt: 0 }}>
//           {t("Enter Verification Code")}
//         </DialogTitle>

//         <DialogContent className="alignByLang">
//           <DialogContentText sx={{ mb: 3, textAlign: 'center', color: theme.palette.text.secondary }}>
//             {t("We've sent a verification code to")}
//             <span
//               style={{
//                 fontWeight: 'bold',
//                 color: theme.palette.text.primary,
//                 direction: 'ltr',
//                 unicodeBidi: 'bidi-override',
//                 display: 'inline-block',
//               }}
//             >
//               {phone}
//             </span>
//           </DialogContentText>

//           <VerificationCodeInput
//             value={verificationCode}
//             onChange={(code) => {
//               setVerificationCode(code);
//               setVerificationError("");
//             }}
//             error={verificationError}
//           />

//           {verificationError && (
//             <Typography variant="body2" color="error" sx={{ textAlign: 'center', mb: 2 }}>
//               {verificationError}
//             </Typography>
//           )}

//           <Box sx={{ textAlign: 'center', mt: 2, mb: 1 }}>
//             {resendTimer > 0 ? (
//               <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontSize: '0.875rem' }}>
//                 {t("Request new code in")} <span style={{ fontWeight: 'bold' }}>{formatTime(resendTimer)}</span>
//               </Typography>
//             ) : (
//               <Button
//                 onClick={handleResendCode}
//                 color="primary"
//                 size="small"
//                 sx={{ textTransform: 'none', fontSize: '0.875rem' }}
//               >
//                 {t("Didn't receive code? Resend")}
//               </Button>
//             )}
//           </Box>
//         </DialogContent>

//         <DialogActions sx={{ justifyContent: 'space-between', padding: theme.spacing(0, 3, 2), gap: 2 }}>
//           <Button
//             onClick={() => setOpenVerifiyDialog(false)}
//             sx={{
//               textTransform: 'none',
//               color: theme.palette.text.secondary,
//               borderRadius: '12px',
//               px: 3,
//               py: 1
//             }}
//           >
//             {t("Back")}
//           </Button>

//           <Button
//             onClick={handleVerifyCode}
//             variant="contained"
//             sx={{
//               textTransform: 'none',
//               fontWeight: 'bold',
//               px: 3,
//               py: 1,
//               borderRadius: '12px',
//               boxShadow: 'none',
//               '&:hover': {
//                 boxShadow: 'none',
//               }
//             }}
//             disabled={verificationCode.length !== 6}
//           >
//             {t("Verify")}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SaveCustomerNameDialog
//         openSaveNameDialogVal={openSaveNameDialog}
//         customerName={customerName}
//         setCustomerNameVal={(cust_name) => setCustomerName(cust_name)}
//         handleSaveCustomerName={saveCustomerName}
//       />

//       <Toast
//         open={toastSettings.open}
//         message={toastSettings.message}
//         resetToast={handleCloseToast}
//         success={toastSettings.success}
//       />
//     </div>
//   );
// };

// export default LoginComponent;




import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import countryList from "react-select-country-list";
import {
  Backdrop, Button, CircularProgress, Dialog, DialogActions,
  DialogContent, DialogContentText, DialogTitle, TextField,
  Typography, Box, SwipeableDrawer, styled, useTheme, InputAdornment
} from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import PhoneInput, { isValidPhoneNumber, getCountries, getCountryCallingCode } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { t } from "i18next";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import Loading from "../../../common/loading";
import { getLocalStorageMenuItem, setLocalStorageMenuItem } from "../../../utility";
import SaveCustomerNameDialog from "../../SaveCustomerNameDialog";
import { useLocation, useNavigate } from "react-router-dom";
import Toast from "../../../common/toast";
import ReactCountryFlag from "react-country-flag";

// Styled components for the split phone input
const PhoneInputContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  padding: '4px 12px',
  transition: theme.transitions.create(['border-color', 'box-shadow']),
  '&:hover': {
    borderColor: theme.palette.primary.main,
  },
  '&:focus-within': {
    borderColor: theme.palette.primary.main,
    boxShadow: `0 0 0 2px ${theme.palette.primary.light}`,
  },
}));

const CountrySelector = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 0',
  minWidth: '120px',
  borderRight: `1px solid ${theme.palette.divider}`,
  paddingRight: '12px',
  cursor: 'pointer',
}));

const PhoneNumberInput = styled(TextField)(({ theme }) => ({
  flexGrow: 1,
  '& .MuiOutlinedInput-root': {
    border: 'none',
    '&:hover fieldset': {
      border: 'none',
    },
    '&.Mui-focused fieldset': {
      border: 'none',
    },
    '& input': {
      padding: '8px 0',
      border: 'none',
      outline: 'none',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}));

const CountrySelectDropdown = ({ value, onChange, onBlur, ...props }) => {
  const theme = useTheme();
  const options = React.useMemo(() =>
    getCountries().map(country => ({
      value: country,
      label: `${country} +${getCountryCallingCode(country)}`,
      callingCode: getCountryCallingCode(country)
    })),
    []);

  const selectedOption = options.find(option => option.value === value) || options.find(option => option.value === "SA");

  return (
    <Select
      {...props}
      options={options}
      value={selectedOption}
      onChange={(option) => onChange(option.value)}
      onBlur={onBlur}
      components={{
        IndicatorSeparator: () => null,
        DropdownIndicator: () => null,
      }}
      formatOptionLabel={(option) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <ReactCountryFlag
            countryCode={option.value}
            svg
            style={{ width: "1.5em", height: "1.5em" }}
          />
          <span>+{option.callingCode}</span>
        </div>
      )}
      styles={{
        control: (base, state) => ({
          ...base,
          border: 'none',
          boxShadow: 'none',
          backgroundColor: 'transparent',
          minHeight: 'auto',
          '&:hover': {
            border: 'none',
          },
        }),
        valueContainer: (base) => ({
          ...base,
          padding: 0,
        }),
        singleValue: (base) => ({
          ...base,
          margin: 0,
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }),
        menu: (base) => ({
          ...base,
          zIndex: 9999,
          borderRadius: 12,
          overflow: "hidden",
          boxShadow: theme.shadows[4],
          minWidth: "250px",
        }),
        option: (base, state) => ({
          ...base,
          fontSize: "0.9rem",
          padding: "10px 14px",
          backgroundColor: state.isSelected
            ? theme.palette.primary.main
            : state.isFocused
              ? theme.palette.action.hover
              : "transparent",
          color: state.isSelected
            ? theme.palette.primary.contrastText
            : theme.palette.text.primary,
          cursor: "pointer",
          transition: "background-color 0.2s ease",
        }),
      }}
    />
  );
};

const VerificationCodeInput = ({ value, onChange, error }) => {
  const theme = useTheme();
  const inputRefs = useRef([]);
  const [digits, setDigits] = useState(Array(6).fill(''));

  useEffect(() => {
    if (value && value.length === 6) {
      const newDigits = value.split('');
      setDigits(newDigits);
      if (inputRefs.current[5]) {
        inputRefs.current[5].focus();
      }
    }
  }, [value]);

  const handleChange = (index, newValue) => {
    if (newValue && !/^\d*$/.test(newValue)) return;

    const newDigits = [...digits];
    if (newValue.length === 6) {
      const pastedDigits = newValue.split('').slice(0, 6);
      setDigits(pastedDigits);
      onChange(pastedDigits.join(''));
      // Focus the last input
      if (inputRefs.current[5]) {
        inputRefs.current[5].focus();
      }
      return;
    }

    newDigits[index] = newValue.slice(-1);
    setDigits(newDigits);
    const code = newDigits.join('');
    onChange(code);

    if (newValue && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !digits[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
    if (e.key === 'ArrowLeft' && index > 0) {
      inputRefs.current[index - 1].focus();
      e.preventDefault();
    }
    if (e.key === 'ArrowRight' && index < 5) {
      inputRefs.current[index + 1].focus();
      e.preventDefault();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').trim();
    if (!/^\d+$/.test(pastedData)) return; // ignore non-numeric paste

    const chars = pastedData.split('').slice(0, 6); // take up to 6 digits
    const newDigits = Array(6).fill('');
    for (let i = 0; i < chars.length; i++) newDigits[i] = chars[i];
    setDigits(newDigits);
    onChange(newDigits.join(''));

    const nextIndex = Math.min(chars.length, 5);
    if (inputRefs.current[nextIndex]) inputRefs.current[nextIndex].focus();
  }

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      gap: 1,
      mb: 2,
      direction: 'ltr',
    }}>
      {digits.map((digit, index) => (
        <TextField
          key={index}
          inputRef={(el) => (inputRefs.current[index] = el)}
          value={digit}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={handlePaste}
          inputProps={{
            maxLength: index === 0 ? 6 : 1,
            inputMode: 'numeric',
            pattern: '[0-9]*',
            autoComplete: index === 0 ? 'one-time-code' : 'off',  // ADD THIS LINE
            style: {
              textAlign: 'center',
              fontSize: '1.5rem',
              fontWeight: 'bold',
              direction: 'ltr',
              height: "50px",
              width: "50px"
            }
          }}
          sx={{
            width: '150px',
            height: '50px',
            direction: 'ltr',
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
              direction: 'ltr',
              '& input': {
                textAlign: 'center',
                padding: '0',
                direction: 'ltr',
              },
              '& fieldset': {
                borderColor: error ? theme.palette.error.main : theme.palette.divider,
              },
              '&:hover fieldset': {
                borderColor: error ? theme.palette.error.main : theme.palette.primary.main,
              },
              '&.Mui-focused fieldset': {
                borderColor: error ? theme.palette.error.main : theme.palette.primary.main,
                borderWidth: '2px',
              },
            }
          }}
          variant="outlined"
        />
      ))}
    </Box>
  );
};

const LoginComponent = ({ open, handleCloseDialog, tableQr, tableName, onVerificationSuccess, is_from }) => {
  const theme = useTheme();
  const [verificationCode, setVerificationCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [country, setCountry] = useState("SA");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [openVerifiyDialog, setOpenVerifiyDialog] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [openSaveNameDialog, setOpenSaveNameDialog] = useState(false);
  const [token, setToken] = useState("");
  const [resendTimer, setResendTimer] = useState(0);
  const [codeSentTime, setCodeSentTime] = useState(null);
  const [verificationError, setVerificationError] = useState("");
  const [toastSettings, setToastSettings] = useState({
    open: false,
    message: "",
    success: false,
  });

  useEffect(() => {
    let timer;
    if (resendTimer > 0) {
      timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [resendTimer]);


  useEffect(() => {
    if (verificationCode.length === 6) {
      handleVerifyCode();
    }
  }, [verificationCode]);

  const startResendTimer = () => {
    setResendTimer(120);
    setCodeSentTime(new Date());
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const handleOpenToast = (message, state) => {
    setToastSettings({
      open: true,
      success: state,
      message: message
    });
  };

  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setToastSettings({
      open: false,
      message: "",
      success: false
    });
  };

  function useQueryParams() {
    const { search } = useLocation();
    return new URLSearchParams(search);
  }

  const navigate = useNavigate();
  const query = useQueryParams();
  const tParam = query.get("t");
  const lang = query.get("lang");

  const validationSchema = Yup.object().shape({
    phoneNumber: Yup.string()
      .required(t("Phone number is required"))
      .test(
        "isValidPhoneNumber",
        t("Enter a valid phone number"),
        (value) => {
          if (!value) return false;
          // Combine country code and phone number for validation
          const fullNumber = `+${getCountryCallingCode(country)}${value.replace(/\D/g, '')}`;
          return isValidPhoneNumber(fullNumber);
        }
      ),
  });

  const handleOpenSaveNameDialog = (token) => {
    setToken(token);
    setOpenVerifiyDialog(false);
    setOpenSaveNameDialog(true);
  }

  const saveCustomerName = async () => {
    if (!customerName) {
      handleOpenToast(
        <div className="alignByLang">
          {t("Please enter your name.")}
        </div>,
        false
      );
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/customer/save-name`, {
        name: customerName,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });

      if (response?.data?.success) {
        handleOpenToast(
          <div className="alignByLang">
            {t("Name updated successfully.")}
          </div>,
          true
        );
        setLocalStorageMenuItem("mobileLoginToken", token || "");
        setLocalStorageMenuItem("customer_name", customerName || "");
        setLocalStorageMenuItem("customer_balance", 0);
        onVerificationSuccess(token);
        setOpenSaveNameDialog(false);
      } else {
        handleOpenToast(
          <div className="alignByLang">
            {t("Error while saving the name.")}
          </div>,
          false
        );
      }
    } catch (error) {
      handleOpenToast(
        <div className="alignByLang">
          {t("Error while saving the name: ") + error.message}
        </div>,
        false
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSendCode = async (values) => {
    setLoading(true);
    try {
      // Format the phone number with country code
      const fullPhoneNumber = `+${getCountryCallingCode(country)}${values.phoneNumber.replace(/\D/g, '')}`;

      const response = await axios.post(`${process.env.REACT_APP_API}/customer/send-otp`, {
        phone: fullPhoneNumber,
        menu_code: tableQr,
      });

      if (response?.data?.success) {
        setPhone(fullPhoneNumber);
        // await handleVerifyCodeTemp(fullPhoneNumber, "123456");
        handleCloseDialog();

        setOpenVerifiyDialog(true);
        startResendTimer();
        handleOpenToast(
          <div className="alignByLang">
            {t("Verification code sent successfully.")}
          </div>,
          true
        );
      } else {
        handleOpenToast(
          <div className="alignByLang">
            {t("Error while sending the verification code.")}
          </div>,
          false
        );
      }
    } catch (error) {
      handleOpenToast(
        <div className="alignByLang">
          {t("Error while sending the verification code: ") + error.message}
        </div>,
        false
      );
    } finally {
      setLoading(false);
    }
  };

  const handleResendCode = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/customer/send-otp`, {
        phone: phone,
        menu_code: tableQr,
      });

      if (response?.data?.success) {
        startResendTimer();
        handleOpenToast(
          <div className="alignByLang">
            {t("New verification code sent successfully.")}
          </div>,
          true
        );
      } else {
        handleOpenToast(
          <div className="alignByLang">
            {t("Error while resending the verification code.")}
          </div>,
          false
        );
      }
    } catch (error) {
      handleOpenToast(
        <div className="alignByLang">
          {t("Error while resending the verification code: ") + error.message}
        </div>,
        false
      );
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyCode = async () => {
    if (!verificationCode || verificationCode.length !== 6) {
      setVerificationError(t("Please enter a valid 6-digit code"));
      return;
    }

    setLoading(true);
    setVerificationError("");

    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/customer/check-otp`, {
        phone,
        otp: verificationCode,
      });

      if (response?.data?.success) {
        setVerificationCode("");
        if (response?.data?.data?.name) {
          setLocalStorageMenuItem("customer_name", response?.data?.data?.name || "");
          setLocalStorageMenuItem("customer_balance", response?.data?.data?.balance || 0);
          setLocalStorageMenuItem("mobileLoginToken", response?.data?.data?.token || "");
          onVerificationSuccess(response?.data?.data?.token);
          setOpenVerifiyDialog(false);

          if (is_from === 1) {
            navigate(`/${tableName}/${tableQr}/sections?section=0&t=${tParam}&lang=${lang}`, { replace: true });
          } else if (is_from === 2) {
            window.location.reload();
          }
        } else {
          handleOpenSaveNameDialog(response?.data?.data?.token);
        }
      } else {
        setVerificationError(t("Invalid verification code. Please try again."));
        handleOpenToast(
          <div className="alignByLang">
            {t("Invalid verification code. Please try again.")}
          </div>,
          false
        );
      }
    } catch (error) {
      setVerificationError(t("Error verifying code"));
      handleOpenToast(
        <div className="alignByLang">
          {t("Error while verifying the code: ") + error.message}
        </div>,
        false
      );
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyCodeTemp = async (temp_phone, code) => {
    if (!code || code.length !== 6) {
      setVerificationError(t("Please enter a valid 6-digit code"));
      return;
    }

    setLoading(true);
    setVerificationError("");

    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/customer/check-otp`, {
        phone: temp_phone,
        otp: code,
      });

      if (response?.data?.success) {
        setVerificationCode("");
        if (response?.data?.data?.name) {
          setLocalStorageMenuItem("customer_name", response?.data?.data?.name || "");
          setLocalStorageMenuItem("customer_balance", response?.data?.data?.balance || 0);
          setLocalStorageMenuItem("mobileLoginToken", response?.data?.data?.token || "");
          onVerificationSuccess(response?.data?.data?.token);
          setOpenVerifiyDialog(false);

          if (is_from === 1) {
            navigate(`/${tableName}/${tableQr}/sections?section=0&t=${tParam}&lang=${lang}`, { replace: true });
          } else if (is_from === 2) {
            window.location.reload();
          }
        } else {
          handleOpenSaveNameDialog(response?.data?.data?.token);
        }
      } else {
        setVerificationError(t("Invalid verification code. Please try again."));
        handleOpenToast(
          <div className="alignByLang">
            {t("Invalid verification code. Please try again.")}
          </div>,
          false
        );
      }
    } catch (error) {
      setVerificationError(t("Error verifying code"));
      handleOpenToast(
        <div className="alignByLang">
          {t("Error while verifying the code: ") + error.message}
        </div>,
        false
      );
    } finally {
      setLoading(false);
    }
  };

  // Format phone number as user types (Saudi format)
  const formatPhoneNumber = (value) => {
    if (!value) return value;

    // Remove all non-digit characters
    const digitsOnly = value.replace(/\D/g, '');

    // Apply Saudi format: 5X XXX XXXX
    if (digitsOnly.length <= 1) return digitsOnly;
    if (digitsOnly.length <= 4) return `${digitsOnly.slice(0, 1)} ${digitsOnly.slice(1)}`;
    if (digitsOnly.length <= 7) return `${digitsOnly.slice(0, 1)} ${digitsOnly.slice(1, 4)} ${digitsOnly.slice(4)}`;
    return `${digitsOnly.slice(0, 1)} ${digitsOnly.slice(1, 4)} ${digitsOnly.slice(4, 7)} ${digitsOnly.slice(7, 9)}`;
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      <ToastContainer />
      <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Phone Number Drawer */}
      <SwipeableDrawer
        anchor="bottom"
        open={open}
        onClose={handleCloseDialog}
        onOpen={() => { }}
        disableSwipeToOpen={true}
        PaperProps={{
          sx: {
            borderTopLeftRadius: '16px',
            borderTopRightRadius: '16px',
            padding: theme.spacing(3, 2, 4),
            background: theme.palette.background.paper,
            boxShadow: theme.shadows[10],
          }
        }}
      >
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <Box sx={{
            width: '40px',
            height: '4px',
            backgroundColor: theme.palette.divider,
            borderRadius: '2px',
            margin: '0 auto 16px',
          }} />
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.text.primary, mb: 1 }}>
            {t("Welcome")}
          </Typography>
          <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 3 }}>
            {t("Enter your phone number to continue")}
          </Typography>
        </Box>

        <Formik
          initialValues={{ phoneNumber: "" }}
          validationSchema={validationSchema}
          onSubmit={handleSendCode}
        >
          {({ values, setFieldValue, errors, touched, handleBlur }) => (
            <Form>
              <PhoneInputContainer>
                <CountrySelector>
                  <CountrySelectDropdown
                    value={country}
                    onChange={setCountry}
                    onBlur={handleBlur}
                  />
                </CountrySelector>
                <PhoneNumberInput
                  name="phoneNumber"
                  placeholder={t("Phone number")}
                  value={values.phoneNumber}
                  onChange={(e) => {
                    let inputValue = e.target.value;
                    if (inputValue.startsWith("0")) {
                      inputValue = inputValue.substring(1);
                    }
                    const formatted = formatPhoneNumber(e.target.value);
                    setFieldValue("phoneNumber", inputValue);
                  }}
                  onBlur={handleBlur}
                  fullWidth
                  variant="outlined"
                  error={touched.phoneNumber && Boolean(errors.phoneNumber)}
                  inputProps={{
                    style: {
                      textAlign: 'center',
                      textAlign: getLocalStorageMenuItem("lang") === "ar" ? 'center' : 'center'
                    }
                  }}
                  // Or if it uses InputProps instead:
                  InputProps={{
                    style: {
                      textAlign: 'center',
                      textAlign: getLocalStorageMenuItem("lang") === "ar" ? 'center' : 'center'
                    }
                  }}
                />
              </PhoneInputContainer>

              <ErrorMessage
                name="phoneNumber"
                component="div"
                style={{
                  color: theme.palette.error.main,
                  margin: '8px 0 16px',
                  fontSize: '0.875rem',
                  textAlign: 'center'
                }}
              />

              <Button
                type="submit"
                variant="contained"
                fullWidth
                size="large"
                sx={{
                  mt: 2,
                  py: 1.5,
                  fontWeight: 'bold',
                  textTransform: 'none',
                  fontSize: '1rem',
                  borderRadius: '12px',
                  boxShadow: 'none',
                  '&:hover': {
                    boxShadow: 'none',
                  }
                }}
              >
                {t("Continue")}
              </Button>
            </Form>
          )}
        </Formik>
      </SwipeableDrawer>

      {/* Verification Code Dialog */}
      <Dialog
        open={openVerifiyDialog}
        onClose={() => setOpenVerifiyDialog(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: '16px',
            padding: theme.spacing(3),
            background: theme.palette.background.paper,
          }
        }}
      >
        <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', px: 0, pt: 0 }}>
          {t("Enter Verification Code")}
        </DialogTitle>

        <DialogContent className="alignByLang">
          <DialogContentText sx={{ mb: 3, textAlign: 'center', color: theme.palette.text.secondary }}>
            {t("We've sent a verification code to")}
            <span
              style={{
                fontWeight: 'bold',
                color: theme.palette.text.primary,
                direction: 'ltr',
                unicodeBidi: 'bidi-override',
                display: 'inline-block',
              }}
            >
              {phone}
            </span>
          </DialogContentText>

          <input
            type="tel"
            name="tel"
            value={phone}
            autoComplete="tel"
            style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }}
            readOnly
          />

          <VerificationCodeInput
            value={verificationCode}
            onChange={(code) => {
              setVerificationCode(code);
              setVerificationError("");
            }}
            error={verificationError}
          />

          {verificationError && (
            <Typography variant="body2" color="error" sx={{ textAlign: 'center', mb: 2 }}>
              {verificationError}
            </Typography>
          )}

          <Box sx={{ textAlign: 'center', mt: 2, mb: 1 }}>
            {resendTimer > 0 ? (
              <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontSize: '0.875rem' }}>
                {t("Request new code in")} <span style={{ fontWeight: 'bold' }}>{formatTime(resendTimer)}</span>
              </Typography>
            ) : (
              <Button
                onClick={handleResendCode}
                color="primary"
                size="small"
                sx={{ textTransform: 'none', fontSize: '0.875rem' }}
              >
                {t("Didn't receive code? Resend")}
              </Button>
            )}
          </Box>
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'space-between', padding: theme.spacing(0, 3, 2), gap: 2 }}>
          <Button
            onClick={() => setOpenVerifiyDialog(false)}
            sx={{
              textTransform: 'none',
              color: theme.palette.text.secondary,
              borderRadius: '12px',
              px: 3,
              py: 1
            }}
          >
            {t("Back")}
          </Button>

          <Button
            onClick={handleVerifyCode}
            variant="contained"
            sx={{
              textTransform: 'none',
              fontWeight: 'bold',
              px: 3,
              py: 1,
              borderRadius: '12px',
              boxShadow: 'none',
              '&:hover': {
                boxShadow: 'none',
              }
            }}
            disabled={verificationCode.length !== 6}
          >
            {t("Verify")}
          </Button>
        </DialogActions>
      </Dialog>

      <SaveCustomerNameDialog
        openSaveNameDialogVal={openSaveNameDialog}
        customerName={customerName}
        setCustomerNameVal={(cust_name) => setCustomerName(cust_name)}
        handleSaveCustomerName={saveCustomerName}
      />

      <Toast
        open={toastSettings.open}
        message={toastSettings.message}
        resetToast={handleCloseToast}
        success={toastSettings.success}
      />
    </div>
  );
};

export default LoginComponent;